export function throttle(fn, wait = 0) {
    let timer = 0;
    let lastTime = 0;
    let lastArgs;
    let result;
    const next = (time = Date.now()) => {
        lastTime = time;
        const tmpArgs = lastArgs;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = 0;
        }
        result = fn.apply(null, tmpArgs);
        return result;
    };
    const wrap = (...args) => {
        const now = Date.now();
        const during = now - lastTime;
        lastArgs = args;
        // see: lodash.debounce > shouldInvoke
        if (during >= wait || during < 0) {
            return next(now);
        }
        if (!timer) {
            timer = window.setTimeout(next, wait - during);
        }
        return result;
    };
    wrap.flush = () => {
        if (timer) {
            return next();
        }
        return result;
    };
    return wrap;
}
//# sourceMappingURL=throttle.js.map